const Common = {}

window.baeminWebViewWillAppear = function() {}

Common.install = (Vue) => {
  Vue.prototype.$baeminWebViewWillAppear = () => {
    window.baeminWebViewWillAppear()
    alert('hihihi')
  }

  Vue.prototype.$bodyScrollLock = () => {
    const appBody = document.getElementById('app')
    const { body } = document
    appBody.classList.add('scroll-off')
    body.classList.add('scroll-off')
  }

  Vue.prototype.$bodyScrollUnLock = () => {
    const appBody = document.getElementById('app')
    const { body } = document
    appBody.classList.remove('scroll-off')
    body.classList.remove('scroll-off')
  }

  Vue.prototype.$hideVirtualKeyboard = () => {
    if (document.activeElement && document.activeElement.blur && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur()
    }
  }

  Vue.prototype.$customConfirm = function(message, confirmMethod) {
    const isAndroid = this.$store.getters.isAndroid()
    this.$bodyScrollLock()

    if (isAndroid) {
      const isConfirm = confirm(message)
      if (isConfirm && this._.isFunction(confirmMethod)) {
        confirmMethod()
      }

      this.$bodyScrollUnLock()
    } else {
      this.$modal.show('dialog', {
        text: message,
        buttons: [
          {
            title: '취소',
            handler: () => {
              this.$bodyScrollUnLock()
              this.$modal.hide('dialog')
            }
          },
          {
            title: '확인',
            default: true,
            handler: async () => {
              this.$bodyScrollUnLock()
              if (this._.isFunction(confirmMethod)) {
                await confirmMethod()
              }
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    }
  }

  Vue.prototype.$customAlert = function(message, confirmHandler, buttonTitle, headerTitle) {
    if (buttonTitle === undefined || buttonTitle === null) {
      buttonTitle = '확인'
    }
    this.$bodyScrollLock()
    this.$modal.show('temp-modal')
    this.$modal.hide('temp-modal')
    const props = {
      title: headerTitle,
      text: message,
      buttons: [
        {
          title: buttonTitle,
          default: true,
          handler: () => {
            if (this._.isFunction(confirmHandler)) {
              confirmHandler()
            }
            this.$bodyScrollUnLock()
            this.$modal.hide('dialog')
          }
        }
      ]
    }
    setTimeout(() => {
      this.$modal.show('dialog', props)
    }, 100)
  }

  Vue.prototype.$closeWebView = function() {
    const closeUrl = process.env.VUE_APP_CLOSE_URL
    window.location.replace(closeUrl)
  }

  Vue.prototype.$showNavigationBar = function(isAndroid) {
    if (isAndroid) {
      return MarketOrdJavaScriptInterface.showToolBar()
    }

    if (window.webkit === undefined) return null

    if (window.webkit.messageHandlers !== undefined) {
      window.webkit.messageHandlers.visible.postMessage('show')
    }
  }

  Vue.prototype.$hideNavigationBar = function(isAndroid) {
    if (isAndroid) {
      return MarketOrdJavaScriptInterface.hideToolBar()
    }

    if (window.webkit === undefined) return null

    if (window.webkit.messageHandlers !== undefined) {
      return window.webkit.messageHandlers.visible.postMessage('hide')
    }
  }

  Vue.prototype.$lpad = function(text, padLength, padString) {
    if (text === undefined || text === null) {
      return ''
    }
    let s = text.toString()
    while (s.length < padLength) {
      s = padString + s
    }
    return s
  }
}

export default Common
